var __TEMP__ = require('./_baseIndexOf.js');var baseIndexOf = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = charsStartIndex;
